module.exports = __webpack_public_path__ + "img/kei_old_sam.ee03458c.gif";